// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueMeta from 'vue-meta'

/* 路由 */
import router from './router'
import store from './store'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/* 图片懒加载 */
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './assets/images/error.png',  // 替换为实际的错误图片路径
  loading: './assets/images/loading.gif', // 替换为实际的加载图片路径
  attempt: 1,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
})

/* 引入API配置 */
import './api/config'

/* i18n */
import i18n from './i18n'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)

/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

/* 响应式图片组件 */
import ResponsiveImage from './components/ResponsiveImage'
Vue.component(ResponsiveImage.name, ResponsiveImage)

/* 面包屑导航组件 */
import Breadcrumb from './components/Breadcrumb'
Vue.component(Breadcrumb.name, Breadcrumb)

/* 引入公共CSS文件 */
import './assets/css/common.css'

Vue.config.productionTip = false

// 是否打印日志
console.log = () => {}

// 配置 vue-meta - 自动处理页面元数据
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
  keyName: 'metaInfo'
})

// 全局路由守卫：滚动到顶部
router.beforeEach((to, from, next) => {
  next();
});

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js